// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.movesearch-container {
  max-width: 15vw;
  margin-right: 5px;
  align-content: center; }

.breadcrumb-switch-container {
  display: flex;
  color: white;
  align-items: center; }
  .breadcrumb-switch-container .breadcrumb-switch-title {
    margin-left: 3px;
    margin-right: 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 17vw;
    overflow: hidden;
    max-width: fit-content; }

.breadcrumb-subtitle {
  font-weight: bold;
  top: 0;
  position: relative;
  margin-bottom: 0; }

.breadcrumb-subtitle--parent-section {
  color: #838487; }

.breadcrumb-container {
  display: flex;
  justify-content: space-between;
  margin-right: 10px; }
  .breadcrumb-container .form-switch {
    cursor: pointer; }
    .breadcrumb-container .form-switch input {
      cursor: pointer; }
  .breadcrumb-container .breadcrumb-switch-container-absolute {
    justify-content: flex-end;
    margin-right: 320px; }
  .breadcrumb-container .breadcrumb-subtitle {
    max-width: 80vw;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden; }
  .breadcrumb-container .spacer {
    display: block;
    font-size: 0.625em;
    line-height: 0.1em;
    width: 10px; }
  .breadcrumb-container .location:hover {
    text-decoration: underline;
    cursor: pointer; }

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .breadcrumb-container .breadcrumb-switch-container-absolute {
    margin-right: 210px; }
    .breadcrumb-container .breadcrumb-switch-container-absolute .breadcrumb-switch-title {
      overflow: unset;
      font-size: 14px; } }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/reports/shared/breadcrumb-styles.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACrBrD;EACI,eAAe;EACf,iBAAiB;EACjB,qBAAqB,EAAA;;AAGzB;EACI,aAAa;EACb,YAAY;EACZ,mBAAmB,EAAA;EAHvB;IAKQ,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,sBAAsB,EAAA;;AAK9B;EACE,iBAAiB;EACjB,MAAM;EACN,kBAAkB;EAClB,gBAAgB,EAAA;;AAElB;EACE,cDhB8B,EAAA;;ACoBhC;EACI,aAAa;EACb,8BAA8B;EAC9B,kBAAkB,EAAA;EAHtB;IAOQ,eAAe,EAAA;IAPvB;MASY,eAAe,EAAA;EAT3B;IAcQ,yBAAyB;IACzB,mBAAmB,EAAA;EAf3B;IAmBQ,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB,EAAA;EAtBxB;IA0BQ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,WAAW,EAAA;EA7BnB;IAkCY,0BAA0B;IAC1B,eAAe,EAAA;;AAM3B;EACI;IAEQ,mBAAmB,EAAA;IAF3B;MAIY,eAAe;MACf,eAAe,EAAA,EAClB","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../../theme/_variables.scss\";\n\n.movesearch-container {\n    max-width: 15vw;\n    margin-right: 5px;\n    align-content: center;\n}\n\n.breadcrumb-switch-container {\n    display: flex;\n    color: white;\n    align-items: center;\n    .breadcrumb-switch-title {\n        margin-left: 3px;\n        margin-right: 8px;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        width: 17vw;\n        overflow: hidden;\n        max-width: fit-content;\n    }\n}\n\n\n.breadcrumb-subtitle {\n  font-weight: bold;\n  top: 0;\n  position: relative;\n  margin-bottom: 0;\n}\n.breadcrumb-subtitle--parent-section {\n  color: $secondarySubtitleColor;\n}\n\n\n.breadcrumb-container {\n    display: flex;\n    justify-content: space-between;\n    margin-right: 10px;\n\n\n    .form-switch {\n        cursor: pointer;\n        input {\n            cursor: pointer;\n        }\n    }\n\n    .breadcrumb-switch-container-absolute {   \n        justify-content: flex-end;\n        margin-right: 320px;\n    }\n\n    .breadcrumb-subtitle {\n        max-width: 80vw;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n    }\n\n    .spacer {\n        display: block;\n        font-size: 0.625em;\n        line-height: 0.1em;\n        width: 10px;\n    }\n\n    .location {\n        &:hover { \n            text-decoration: underline; \n            cursor: pointer;\n        }\n    }\n\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n    .breadcrumb-container {\n        .breadcrumb-switch-container-absolute {   \n            margin-right: 210px;\n            .breadcrumb-switch-title {\n                overflow: unset;\n                font-size: 14px;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
